import { render, staticRenderFns } from "./FormComprador.vue?vue&type=template&id=27d44d9c&scoped=true"
import script from "./FormComprador.vue?vue&type=script&lang=js"
export * from "./FormComprador.vue?vue&type=script&lang=js"
import style0 from "./FormComprador.vue?vue&type=style&index=0&id=27d44d9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d44d9c",
  null
  
)

export default component.exports